<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-header">
        <h3 v-if="mData.viewMode === 'create'">
          THÊM MỚI PHƯƠNG THỨC THANH TOÁN
        </h3>
        <h3 v-if="mData.viewMode === 'detail'">
          CHI TIẾT PHƯƠNG THỨC THANH TOÁN
        </h3>
        <h3 v-if="mData.viewMode === 'update'">
          CẬP NHẬT PHƯƠNG THỨC THANH TOÁN
        </h3>
      </div>

      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm">
          <b-row>
            <b-col md="6">
              <el-form-item label="Tên" prop="ten">
                <el-input
                  v-model="mData.dataForm.ten"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  @input="forceUpdateUI"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Mã thanh toán" prop="ma">
                <el-input
                  v-model="mData.dataForm.ma"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                >
                </el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Hiệu lực từ">
                <el-date-picker
                  v-model="mData.dataForm.hieu_luc.tu"
                  format="dd/MM/yyyy HH:mm:ss"
                  :default-time="['12:00:00']"
                  :disabled="mData.viewMode == 'detail'"
                  @input="$forceUpdate()"
                >
                </el-date-picker>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Hiệu lực đến">
                <el-date-picker
                  v-model="mData.dataForm.hieu_luc.den"
                  format="dd/MM/yyyy HH:mm:ss"
                  :default-time="['12:00:00']"
                  :disabled="mData.viewMode == 'detail'"
                  @input="$forceUpdate()"
                >
                </el-date-picker>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="">
                <br />
                <el-checkbox
                  style="margin-top: 5px"
                  @change="fn_hideDichVu"
                  :disabled="mData.viewMode == 'detail'"
                  v-model="mData.dataForm.hieu_luc.an"
                  >Ẩn phương thức thanh toán</el-checkbox
                >
              </el-form-item>
            </b-col>
          </b-row>

          <div class="text-center mt-3">
            <el-button
              type="danger"
              plain
              @click="fn_cancel()"
              v-ladda
              v-if="mData.viewMode === 'update' || mData.viewMode === 'create'"
              >hủy</el-button
            >
            <el-button
              type="primary"
              @click="fn_addCongKhai()"
              v-ladda
              v-if="mData.viewMode === 'create'"
              >thêm mới</el-button
            >
            <el-button
              type="primary"
              @click="fn_update()"
              v-ladda
              v-if="mData.viewMode === 'update'"
              >cập nhật</el-button
            >
            <el-button
              type="primary"
              @click="fn_back()"
              v-ladda
              v-if="mData.viewMode === 'detail'"
              >quay lại</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import mushroom from "viettoc-api";
import ValidService from "../../../service/ValidService";
import MethodService from "../../../service/MethodService";
import LanguageService from "../../../service/LanguageService";
import DataForm from "../../../dataForm/dataFormPhuongThucThanhToan";
import { Circle4 } from "vue-loading-spinner";
export default {
  components: {
    Circle4,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      hideDichVu: false,
      loading: true,
      mData: {
        viewMode: "create",
        dataForm: MethodService.copyObject(DataForm.dataForm),
        tableRules: MethodService.copyObject(DataForm.tableRules),
      },
    };
  },
  methods: {
    async fn_initForm() {
      try {
        const response = await mushroom.phuong_thuc_thanh_toan.findByIdAsync({
          id: this.$router.currentRoute.params.id,
          fields: "id,ma,ten,hieu_luc",
        });
        this.mData.dataForm = response.result;

        this.loading = false;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    // thêm Dich Vu
    // async fn_addCongKhai() {
    //   const ldp_DichVu_object = {
    //     ten: this.mData.dataForm.ten,
    //     gioi_thieu: this.mData.dataForm.gioi_thieu,
    //     thoi_diem_cap_nhat: this.mData.dataForm.thoi_diem_cap_nhat,
    //     cong_khai: this.mData.dataForm.cong_khai,
    //   };
    //   this.$refs["myForm"].validate(async (valid) => {
    //     if (valid) {
    //       console.log(ldp_DichVu_object);
    //       if (
    //         this.mData.dataForm.anh_id == undefined &&
    //         this.mData.dataForm.video_id == undefined
    //       ) {
    //         window.toastr.warning("Cần upload ảnh hoặc video");
    //         MethodService.stopLadda();
    //       } else {
    //         try {
    //           await mushroom.ldp_slide.createAsync(ldp_DichVu_object);
    //           MethodService.stopLadda();
    //           this.fn_resetForm();
    //           this.fn_resetDataForm();
    //           window.toastr.success("Thêm mới Slide thành công");
    //           this.$router.push({
    //             name: "DanhSachSlide",
    //           });
    //         } catch (error) {
    //           console.log(error);
    //           console.log(this.$refs.myForm.$el);
    //           if (error.code === 4) {
    //             window.toastr.error(this.aLang.no_server);
    //           } else if (error.code === 2) {
    //             window.toastr.error("Gặp sự cố tải dữ liệu");
    //           } else {
    //             window.toastr.error("Đã có lỗi xảy ra");
    //           }
    //         }
    //       }
    //     } else {
    //       MethodService.stopLadda();
    //       return false;
    //     }
    //   });
    // },
    fn_hideDichVu() {
      console.log("change");
      this.hideDichVu = !this.hideDichVu;
      this.mData.dataForm.cong_khai = this.hideDichVu;
    },

    // quay lại danh sách dịch vụ
    fn_back() {
      this.$router.go(-1);
    },

    // reset form
    fn_resetForm() {
      this.$refs.myForm.$el.reset();
    },
    fn_resetDataForm() {
      this.mData.dataForm.thu_tu = undefined;
      this.mData.dataForm.anh_id = null;
      this.mData.dataForm.anh_show = false;
      this.mData.dataForm.anh_btn_show = false;
      this.mData.dataForm.anh_url = undefined;
      this.mData.dataForm.anh_nho_show = false;
      this.mData.dataForm.anh_nho_id = null;
      this.mData.dataForm.anh_nho_url = undefined;
      this.mData.dataForm.anh_nho_btn_show = false;
      this.mData.dataForm.anh_nho_url = undefined;
      this.mData.dataForm.video_show = false;
      this.mData.dataForm.video_id = null;
      this.mData.dataForm.video_url = undefined;
      this.mData.dataForm.video_btn_show = false;
    },
    fn_cancel() {
      this.fn_resetForm();
      this.fn_resetDataForm();
      this.$router.go(-1);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
  },

  async created() {
    // kiểm tra loại viewMode
    console.log(this.$router.currentRoute.name);
    // if (this.$router.currentRoute.name == "ThemGoiDichVu") {
    //   this.mData.viewMode = "create";
    //   this.loading = false;
    // }
    if (this.$router.currentRoute.name == "ChiTietPhuongThucThanhToan") {
      this.mData.viewMode = "detail";
      await this.fn_initForm();
    }
    if (this.$router.currentRoute.name == "CapNhatPhuongThucThanhToan") {
      this.mData.viewMode = "update";
      await this.fn_initForm();
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
